import { makeStyles } from '@material-ui/core';
import { orange } from '@material-ui/core/colors';

export const editarProdutoModalStyles = makeStyles((theme) => ({
  produtoImagemUpload: {
    transitionProperty: 'box-shadow',
    transitionDuration: theme.transitions.duration.short,
    transitionTimingFunction: theme.transitions.easing.easeInOut,
  },
  productImageItem: {
    transitionProperty: 'box-shadow',
    transitionDuration: theme.transitions.duration.short,
    transitionTimingFunction: theme.transitions.easing.easeInOut,
    textAlign: 'center',
    '&.error': {
      boxShadow: '0 3px 5px 2px rgba(207, 66, 56, 0.6)',
    },
    '&.error:hover': {
      boxShadow: '0 3px 5px 2px rgba(207, 66, 56, 0.8)',
    },
  },
  imageIcon: {
    display: 'inline-block',
    height: '100%',
    verticalAlign: 'middle',
    position: 'absolute',
    '&.error': {
      color: 'rgb(207, 66, 56)',
    },
  },
  '@keyframes loading': {
    '0%': {
      filter: 'blur(0px)',
      '-webkit-filter': 'blur(0px)',
    },
    '50%': {
      filter: 'blur(5px)',
      '-webkit-filter': 'blur(5px)',
    },
    '100%': {
      filter: 'blur(0px)',
      '-webkit-filter': 'blur(0px)',
    },
  },
  imageLoading: {
    animation: '$loading 2000ms infinite',
  },
  productImageFeaturedStar: {
    position: 'absolute',
    top: 0,
    right: 0,
    color: orange[400],
    opacity: 0,
  },
  imagemContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  buttonDelete: {
    color: 'rgb(207, 66, 56)',
    '&:hover': {
      backgroundColor: 'rgba(207, 66, 56, 0.1)',
      boxShadow: 'none',
    },
    '&:active': {
      boxShadow: 'none',
      backgroundColor: 'rgba(207, 66, 56, 0.3)',
      borderColor: 'rgba(207, 66, 56, 0.3)',
    },
    '&:focus': {
      boxShadow: '0 0 0 0.2rem rgba(207, 66, 56,0.0)',
    },
  },
  buttonStar: {
    color: '#c0c0c0',
    '&.principal': {
      color: '#ffa726',
    },
    '&:hover': {
      backgroundColor: 'rgba(255, 167, 38, 0.1)',
      boxShadow: 'none',
    },
    '&:active': {
      boxShadow: 'none',
      backgroundColor: 'rgba(255, 167, 38, 0.3)',
      borderColor: 'rgba(255, 167, 38, 0.3)',
    },
    '&:focus': {
      boxShadow: '0 0 0 0.2rem rgba(255, 167, 38,0.0)',
    },
  },
}));

// 'flex items-center justify-center relative w-128 h-128 rounded-4 mx-8 mb-16 overflow-hidden cursor-pointer shadow-1 hover:shadow-5'
